import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NtactLogo from '../assets/NTACT Logo.svg';
import { Document, Page, Text, View, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import LOgo from '../assets/Ntact.png'
import { Backdrop, CircularProgress } from '@mui/material';
import api from '../api/api';
import { sign } from '@tensorflow/tfjs';
import { isUploadedRef, toDisplayUrl } from './draftImageUtils';
import { useSelector } from 'react-redux';
import SignatureModal from './Signaturemodal';
// PDF styles
const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontSize: 13,
    fontFamily: 'Helvetica',
    flexDirection: 'column',
  },
  header: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20, borderBottom: '1px solid #ccc', paddingBottom: 8 },
  logo: { width: 90, height: 45, marginBottom: 10 },
  title: { fontSize: 18, fontWeight: 'bold' },
  section: { marginBottom: 12 },
  grid: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 12 },
  gridItem: { border: '1px solid #ccc', padding: 6, width: '30%' },
  table: { border: '1px solid #ccc', marginBottom: 12 },
  tableRow: { flexDirection: 'row', borderBottom: '1px solid #ccc', alignItems: 'stretch' },
  tableCell: {
    borderRight: '1px solid #ccc',
    paddingVertical: 4,
    paddingHorizontal: 5,
    flex: 1,
    textAlign: 'center',
    fontSize: 10,
  },
  // The date column carries longer strings now ("Monday, 2026-05-11") so give
  // it a touch more room than the other columns.
  dateCell: { flex: 1.5 },
  tableHeader: { backgroundColor: '#f0f0f0', fontWeight: 'bold' },
  // Subtle row tinting so Day-Off and Equipment rows stand out without
  // breaking the clean table grid.
  dayOffRow: { backgroundColor: '#F9FAFB' },
  equipmentRow: { backgroundColor: '#FFF7ED' },
  dayOffText: { color: '#6B7280', fontWeight: 'bold' },
  equipmentTag: {
    fontSize: 8,
    color: '#92400E',
    fontWeight: 'bold',
  },
  note: { border: '1px solid #ccc', padding: 12, marginBottom: 12 },
  checklist: { marginBottom: 12, border: '1px solid #ccc', padding: 12, backgroundColor: '#fff' },
  checklistItem: { flexDirection: 'row', justifyContent: 'space-between', padding: 6, borderBottom: '1px solid #ccc', alignItems: 'center', minHeight: 28 },
  checklistText: { fontSize: 11, fontWeight: 'normal', textTransform: 'uppercase' },
  radioContainer: { flexDirection: 'row', alignItems: 'center' },
  radioButton: { width: 12, height: 12, borderRadius: 6, border: '2px solid #ccc', marginLeft: 5, padding: 1 },
  radioButtonSelected: { backgroundColor: '#28a745' },
  radioText: { fontSize: 10, marginLeft: 5, marginRight: 10 },
  radioButtonSelectedYes: { backgroundColor: '#28a745' },
  radioButtonSelectedNo: { backgroundColor: '#dc3545' },
  comments: { border: '1px solid #ccc', padding: 12, marginBottom: 10, marginTop: 12 },
  signatureGrid: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 },
  signatureItem: { border: '1px solid #ccc', padding: 8, width: '48%' },
  underline: { borderBottomWidth: 1, borderBottomColor: '#ccc', marginVertical: 5 },
});
const PDFDocument = ({imagesarray, signpreview,   pm_name,
            pm_sign,
            pm_status, commentImageArray, driverName, unitNumber, filledDate, logData, safetyChecks, comments, checkedBy, driverSignature,
            dfData, dfSignPreviews, dfSignOffNotes }) => {
  // Reusable Comments + Images + Signatures fragment. Renders inline at the
  // bottom of Page 1 for equipment forms (single-page layout), or as its
  // own Page for vehicle forms (3-page layout).
  const commentsAndSignatures = (
    <>
      {/* Comments Section */}
      <View style={styles.comments}>
        <Text style={{ fontWeight: 'bold', marginBottom: 5, fontSize: 13 }}>COMMENTS (NOTE ANY ITEMS OR REPAIRS NEEDED)</Text>
        <Text style={{ fontSize: 12 }}>{comments}</Text>
        <View style={styles.underline} />
      </View>

      {commentImageArray && commentImageArray.length > 0 && (
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-start', gap: 8, marginTop: 6, marginBottom: 10 }}>
          {commentImageArray.map((x, index) => (
            <View
              key={index}
              style={{
                width: 120,
                height: 70,
                alignItems: 'center',
                justifyContent: 'center',
                borderWidth: 1,
                borderColor: '#D1D5DB',
                borderRadius: 6,
                backgroundColor: '#FFFFFF',
                marginBottom: 8,
                marginRight: 8,
              }}
            >
              <Image
                source={{ uri: x?.base64_data }}
                style={{ width: 80, height: 65, resizeMode: 'contain', borderRadius: 4 }}
              />
            </View>
          ))}
        </View>
      )}

      {/* Signatures */}
      <View style={styles.signatureGrid}>
        <View style={styles.signatureItem}>
          <Text style={{ fontWeight: 'bold', fontSize: 13 }}>Checked By:</Text>
          <Text style={{ fontSize: 12 }}>{checkedBy}</Text>
          <View style={styles.underline} />
        </View>
        <View style={styles.signatureItem}>
          <Text style={{ fontWeight: 'bold', fontSize: 13 }}>Driver Signature:</Text>
          {imagesarray?.base64_data && (
            <Image
              source={{ uri: imagesarray.base64_data }}
              style={{
                width: 100,
                height: 30,
                resizeMode: 'contain',
                borderWidth: 1,
                borderColor: '#D1D5DB',
                borderRadius: 4,
                backgroundColor: '#fff',
                marginTop: 5,
              }}
            />
          )}
          <View style={styles.underline} />
        </View>
      </View>

      {/* DF Sign-Off Section */}
      {dfData && Object.keys(dfData).length > 0 && (
        <View style={{ border: '1px solid #ccc', padding: 10, marginTop: 12 }}>
          <Text style={{ fontWeight: 'bold', fontSize: 13, marginBottom: 8 }}>Driver Form Sign-Off</Text>
          {Object.entries(dfData).map(([userId, entry]) => {
            const entryName = typeof entry === 'object' ? entry?.name : '';
            const sigUri = dfSignPreviews?.[userId];
            const notes = dfSignOffNotes?.[userId];
            return (
              <View key={userId} style={{ borderBottom: '1px solid #eee', paddingBottom: 8, marginBottom: 8 }}>
                <Text style={{ fontSize: 11, fontWeight: 'bold' }}>
                  {entryName || `User #${userId}`}
                </Text>
                {sigUri && (
                  <Image
                    source={{ uri: sigUri }}
                    style={{
                      width: 120,
                      height: 40,
                      resizeMode: 'contain',
                      borderWidth: 1,
                      borderColor: '#D1D5DB',
                      borderRadius: 4,
                      backgroundColor: '#fff',
                      marginTop: 4,
                    }}
                  />
                )}
                {notes ? (
                  <View style={{ marginTop: 4 }}>
                    <Text style={{ fontSize: 9, fontWeight: 'bold', color: '#555' }}>Notes:</Text>
                    <Text style={{ fontSize: 9, color: '#333' }}>{notes}</Text>
                  </View>
                ) : null}
                <Text style={{ fontSize: 9, color: '#16a34a', marginTop: 3 }}>Signed Off</Text>
              </View>
            );
          })}
        </View>
      )}
    </>
  );

  return (
  <Document>
    {/* PAGE 1: Header + Driver Info + Fuel/Unit + Log Table (auto-wraps).
        For equipment forms, the Comments + Signatures block is appended
        here so the whole PDF fits on one page. */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      {/* Header */}
      <View style={styles.header} wrap={false}>
        <Image src={LOgo} style={styles.logo} />
        <Text style={styles.title}>WEEKLY DRIVER LOG & SAFETY</Text>
        <View style={{ width: 100 }} />
      </View>

      {/* ROW 1 : Driver + Date */}
      <View style={{ flexDirection: "row", marginBottom: 10 }} wrap={false}>
        <View style={{ flex: 1, border: "1px solid #9CA3AF", padding: 5 }}>
          <Text style={{ fontWeight: "bold" }}>Driver:</Text>
          <Text>{driverName}</Text>
          <View style={{ borderBottom: "1px solid #9CA3AF", marginTop: 4 }} />
        </View>
        <View style={{ flex: 1, border: "1px solid #9CA3AF", padding: 5 }}>
          <Text style={{ fontWeight: "bold" }}>Date:</Text>
          <Text>{filledDate}</Text>
          <View style={{ borderBottom: "1px solid #9CA3AF", marginTop: 4 }} />
        </View>
      </View>

      {/* ROW 2 : Unit Number */}
      <View style={{ border: "1px solid #9CA3AF", padding: 5, marginBottom: 10 }}>
        <Text style={{ fontWeight: "bold" }}>Unit #:</Text>
        <Text style={{ flexWrap: "wrap" }}>{unitNumber}</Text>
        <View style={{ borderBottom: "1px solid #9CA3AF", marginTop: 4 }} />
      </View>

      {/* Log Table — header renders ONCE (no `fixed`) so it doesn't
          duplicate at the bottom of a page when rows wrap. Rows still keep
          `wrap={false}` so individual rows never split across pages. */}
      <View style={styles.table}>
        <View style={[styles.tableRow, styles.tableHeader]} wrap={false}>
          <Text style={[styles.tableCell, styles.dateCell]}>Date</Text>
          <Text style={styles.tableCell}>Mileage Start</Text>
          <Text style={styles.tableCell}>Mileage End</Text>
          <Text style={styles.tableCell}>Job #</Text>
          <Text style={styles.tableCell}>Repair/Fill-up Location</Text>
          <Text style={styles.tableCell}>Gallons Fuel</Text>
          <Text style={styles.tableCell}>Total Amount</Text>
          <Text style={styles.tableCell}>Mileage @ Repair/Fill-up</Text>
        </View>
        {logData.length > 0 ? (() => {
          // Group consecutive same-date rows so we can merge
          // date / mileage columns visually in the PDF.
          const dateGroups = [];
          logData.forEach((log) => {
            const last = dateGroups[dateGroups.length - 1];
            if (last && last[0].date === log.date) {
              last.push(log);
            } else {
              dateGroups.push([log]);
            }
          });

          return dateGroups.map((group, gIndex) => {
            const first = group[0];
            const dateText = first.date
              ? `${first.dayLabel ? first.dayLabel + ', ' : ''}${first.date}`
              : first.dayLabel || '-';

            /* ---------- single-row group (no merge needed) ---------- */
            if (group.length === 1) {
              if (first.day_off) {
                return (
                  <View key={gIndex} style={[styles.tableRow, styles.dayOffRow]} wrap={false}>
                    <Text style={[styles.tableCell, styles.dateCell]}>{dateText}</Text>
                    <Text style={[styles.tableCell, styles.dayOffText, { flex: 7 }]}>Day Off</Text>
                  </View>
                );
              }
              if (first.fuel_allocation === 'equipment') {
                return (
                  <View key={gIndex} style={[styles.tableRow, styles.equipmentRow]} wrap={false}>
                    <Text style={[styles.tableCell, styles.dateCell]}>{dateText}</Text>
                    <Text style={styles.tableCell}>{first.mileage_start || '-'}</Text>
                    <Text style={styles.tableCell}>{first.mileage_end || '-'}</Text>
                    <Text style={styles.tableCell}>-</Text>
                    <Text style={styles.tableCell}>
                      <Text style={styles.equipmentTag}>EQUIPMENT  </Text>
                      {first.equipment_description || '-'}
                    </Text>
                    <Text style={styles.tableCell}>{first.gallons_fuel || '-'}</Text>
                    <Text style={styles.tableCell}>{first.total_amount || '-'}</Text>
                    <Text style={styles.tableCell}>-</Text>
                  </View>
                );
              }
              return (
                <View key={gIndex} style={styles.tableRow} wrap={false}>
                  <Text style={[styles.tableCell, styles.dateCell]}>{dateText}</Text>
                  <Text style={styles.tableCell}>{first.mileage_start || '-'}</Text>
                  <Text style={styles.tableCell}>{first.mileage_end || '-'}</Text>
                  <Text style={styles.tableCell}>{first.job_number || '-'}</Text>
                  <Text style={styles.tableCell}>{first.repair_fillup_location || '-'}</Text>
                  <Text style={styles.tableCell}>{first.gallons_fuel || '-'}</Text>
                  <Text style={styles.tableCell}>{first.total_amount || '-'}</Text>
                  <Text style={styles.tableCell}>{first.mileage_at_repair_fillup || '-'}</Text>
                </View>
              );
            }

            /* ---------- multi-row group — merge date + mileage ---------- */
            return (
              <View key={gIndex} style={styles.tableRow} wrap={false}>
                {/* Merged date cell (vertically centred) */}
                <View style={[styles.tableCell, styles.dateCell, { justifyContent: 'center' }]}>
                  <Text>{dateText}</Text>
                </View>
                {/* Merged mileage-start cell */}
                <View style={[styles.tableCell, { justifyContent: 'center' }]}>
                  <Text>{first.mileage_start || '-'}</Text>
                </View>
                {/* Merged mileage-end cell */}
                <View style={[styles.tableCell, { justifyContent: 'center' }]}>
                  <Text>{first.mileage_end || '-'}</Text>
                </View>
                {/* Right side: stacked sub-rows for the remaining 5 columns */}
                <View style={{ flex: 5 }}>
                  {group.map((log, rIndex) => {
                    const subBorder =
                      rIndex < group.length - 1
                        ? { borderBottom: '1px solid #ccc' }
                        : {};
                    if (log.fuel_allocation === 'equipment') {
                      return (
                        <View key={rIndex} style={[{ flexDirection: 'row' }, subBorder, styles.equipmentRow]}>
                          <Text style={styles.tableCell}>-</Text>
                          <Text style={styles.tableCell}>
                            <Text style={styles.equipmentTag}>EQUIPMENT  </Text>
                            {log.equipment_description || '-'}
                          </Text>
                          <Text style={styles.tableCell}>{log.gallons_fuel || '-'}</Text>
                          <Text style={styles.tableCell}>{log.total_amount || '-'}</Text>
                          <Text style={styles.tableCell}>-</Text>
                        </View>
                      );
                    }
                    return (
                      <View key={rIndex} style={[{ flexDirection: 'row' }, subBorder]}>
                        <Text style={styles.tableCell}>{log.job_number || '-'}</Text>
                        <Text style={styles.tableCell}>{log.repair_fillup_location || '-'}</Text>
                        <Text style={styles.tableCell}>{log.gallons_fuel || '-'}</Text>
                        <Text style={styles.tableCell}>{log.total_amount || '-'}</Text>
                        <Text style={styles.tableCell}>{log.mileage_at_repair_fillup || '-'}</Text>
                      </View>
                    );
                  })}
                </View>
              </View>
            );
          });
        })() : (
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, { flex: 8 }]}>No log data available</Text>
          </View>
        )}
      </View>

      {/* Note Section */}
      <View style={styles.note} wrap={false}>
        <Text style={{ fontWeight: 'bold', marginBottom: 5, fontSize: 13 }}>NOTE:</Text>
        <Text style={{ fontSize: 12 }}>Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.</Text>
      </View>
    </Page>

    {/* ===== PAGE 2: SAFETY CHECKLIST ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>

      {/* Safety Checklist */}
      <View style={styles.checklist}>
        <Text style={{ textAlign: 'center', backgroundColor: '#f0f0f0', padding: 8, marginBottom: 8, fontWeight: 'bold', fontSize: 13 }}>
          WEEKLY CHECK (YES = GOOD CONDITION, NO = REQUIRES A COMMENT)
        </Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
          {[
            'ACCIDENT FORM', 'BATTERY', 'BELTS', 'BRAKE FLUID', 'ENGINE OIL', 'FIRE EXTINGUISHER (10lb)', 'FIRST AID KIT',
            'HEADLAMPS & HI-BEAMS', 'HEATER HOSES', 'HITCH, RECEIVER, AND PINS', 'HORN', 'INSURANCE CARD', 'JACK & TIRE IRON',
            'LIGHTS (Parking & BRAKE)', 'MIRRORS', 'PARKING BRAKE', 'RADIATOR FLUID', 'RADIATOR HOSES', 'SEATBELTS', 'SPARE TIRE',
            'STEERING FLUID', 'TIRE PSI', 'TRANSMISSION OIL', 'TURN SIGNALS', 'WASHER FLUID', 'WINDSHIELD WIPERS',
          ].map((item, index) => (
            <View key={index} style={[styles.checklistItem, { width: '50%', margin: '2px 0px' }]}>
              <Text style={styles.checklistText}>{item}</Text>
              <View style={styles.radioContainer}>
                <Text style={styles.radioText}>YES</Text>
                <View style={[styles.radioButton, safetyChecks[item] === 'Yes' && styles.radioButtonSelectedYes]} />
                <Text style={styles.radioText}>NO</Text>
                <View style={[styles.radioButton, safetyChecks[item] === 'No' && styles.radioButtonSelectedNo]} />
              </View>
            </View>
          ))}
        </View>
      </View>

    </Page>

    {/* ===== PAGE 3: COMMENTS + IMAGES + SIGNATURES ===== */}
    <Page size="A4" orientation="landscape" style={styles.page}>
      {commentsAndSignatures}
    </Page>
  </Document>
  );
};

const WDSFormModal = ({ setFormView, rowData, onEdit, handleDfSignOff }) => {
  console.log(rowData)
     const [loader,setLoader]=useState(false)
  const formRef = useRef(null);
  const [pdfBlob, setPdfBlob] = useState(null);
    const [imagesarray,setImagesArray]=useState([])
    const [commentimagesarray,setCommentImagesArray]=useState([])
      const [selectedImage, setSelectedImage] = useState(null);
       const [isModalOpen, setIsModalOpen] = useState(false);
       const [signpreview,setSignPreview]=useState(null)

  // DF (Driver Form) sign-off state
  const user = useSelector((state) => state.user.userDetails);
  const [df_data, setDfData] = useState(rowData?.df_data || {});
  const [dfStatus, setDfStatus] = useState(rowData?.df_status || 'N');
  const [dfSignPreviews, setDfSignPreviews] = useState({});
  const [dfSignatureModalOpen, setDfSignatureModalOpen] = useState(false);
  const [dfSignOffNote, setDfSignOffNote] = useState('');
  const dfSignOffNotesFromServer = rowData?.df_sign_off_notes || {};
  const hasN2 = user?.user_info?.permissions?.includes('N2');

  // Current user already signed?
  const currentUserSigned = df_data && df_data[String(user?.id)]?.status === 'Y';

  // Pending = df_status is P (or Y but still open for additional sign-offs)
  const needsSignOff = dfStatus === 'P' || dfStatus === 'Y';

  // Open signature popup for DF sign-off
  const handleStartDfSignOff = () => {
    setDfSignatureModalOpen(true);
  };

  // Capture DF signature, upload, then call update-df-sign API
  const handleDfSignatureCapture = async (file) => {
    if (!file || !user?.id || !rowData?.id) return;
    setDfSignatureModalOpen(false);
    try {
      setLoader(true);

      // 1) Upload the signature file
      const fd = new FormData();
      fd.append('files', file);
      const uploadResp = await api.post('/v1/forms/upload-files', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const uploaded = uploadResp?.files?.[0];
      const uploadedFileName = uploaded?.file_name || uploaded?.fileName || uploaded;
      if (!uploadedFileName) throw new Error('Signature upload failed');

      // 2) Call update-df-sign
      const userName = user?.firstname
        ? `${user.firstname}${user.lastname ? ' ' + user.lastname : ''}`
        : user?.email || '';
      const res = await api.post(`/v1/forms/${rowData.id}/update-df-sign`, {
        user_id: user.id,
        user_name: userName,
        df_sign: uploadedFileName,
        df_status: 'Y',
        sign_off_notes: dfSignOffNote || '',
      });

      if (res?.status === 200) {
        // Update local df_data with the new entry
        setDfData((prev) => ({
          ...prev,
          [String(user.id)]: { name: userName, status: 'Y' },
        }));
        setDfStatus('Y');
        const localPreview = URL.createObjectURL(file);
        setDfSignPreviews((prev) => ({ ...prev, [user.id]: localPreview }));

        if (typeof handleDfSignOff === 'function') {
          try { handleDfSignOff(rowData, user.id, { skipApi: true }); } catch (e) {}
        }
      } else {
        console.warn('DF sign update non-200:', res);
      }
    } catch (err) {
      console.error('DF Sign off failed:', err);
    } finally {
      setLoader(false);
    }
  };

  // Fetch existing DF signatures for signed users
  const fetchDfSignature = async (userId) => {
    const cacheBuster = new Date().getTime();
    const canonicalUrl = `https://hub2.ntactops.com/ntact/files/forms_files/${rowData.id}_${userId}_dfsign.png?cb=${cacheBuster}`;
    try {
      const response = await api.post("/v1/images/to-base64", {
        image_url: canonicalUrl,
      });
      if (response.status === 200 && response.data?.base64) {
        setDfSignPreviews((prev) => ({
          ...prev,
          [userId]: `data:image/png;base64,${response.data.base64}`,
        }));
      }
    } catch (err) {
      console.log("No DF signature for user:", userId);
    }
  };

         const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };
        const closeModal = () => {
    setSelectedImage(null); // Clear the selected image
    setIsModalOpen(false);
  };

  // Extract relevant data from rowData
  const driverName = rowData?.emp_name || 'N/A';
  const unitNumber =
    rowData?.json_data?.find((item) => item.question === 'Driver Information - Unit Number')?.answer || 'N/A';
  const filledDate = rowData?.filled_date || 'N/A';
let pm_sign=rowData?.pm_sign
let pm_status=rowData?.pm_status
const pm_name=rowData?.pm_name
  // Extract log data — supports the per-entry shape used by the mobile app:
  // each row can be a normal vehicle row, a "Day Off" row, or an
  // equipment-allocated row (equipmentDescription instead of mileage/job).
  // Each saved entry may carry MULTIPLE fill-up stops (`fillUps[]`). We expand
  // every entry into one-or-more table rows: the first row shows the day's
  // mileage/job + the first fill-up; each additional fill-up becomes its own
  // continuation row (mileage/job columns left blank). Legacy single-fill-up
  // rows (flat location/gallons/amount/mileage) still work via the fallback.
  const rawLogEntries =
    rowData?.json_data?.find((item) => item.question === 'Driver Log Entries')
      ?.answer || [];

  const logData = rawLogEntries.flatMap((log) => {
    const isDayOff = log.dayOff === true || log.dayOff === 'true';
    // Legacy data may have entry-level fuelAllocation; new data has it per fill-up.
    const legacyEntryAlloc = log.fuelAllocation === 'equipment' ? 'equipment' : 'vehicle';
    const base = {
      date: log.date || '',
      dayLabel: log.dayLabel || '',
      day_off: isDayOff,
      fuel_allocation: 'vehicle',
      equipment_description: log.equipmentDescription || '',
      mileage_start: log.Start || '',
      mileage_end: log.End || '',
      job_number: log.Job || '',
    };

    if (isDayOff) {
      return [{ ...base, repair_fillup_location: '', gallons_fuel: '', total_amount: '', mileage_at_repair_fillup: '' }];
    }

    // Normalise fill-ups into an array (new `fillUps` array OR legacy flat fields).
    let fillUps = [];
    if (Array.isArray(log.fillUps) && log.fillUps.length > 0) {
      fillUps = log.fillUps.map((f) => ({
        location: f.location || '',
        gallons: f.gallons || '',
        amount: f.amount ?? f.totalAmount ?? '',
        mileage: f.mileage ?? f.mileageAtRepair ?? '',
        equipmentDescription: f.equipmentDescription || '',
        // Each fill-up carries its own allocation; fall back to legacy entry-level.
        fuelAllocation:
          f.fuelAllocation === 'equipment' ? 'equipment'
          : f.fuelAllocation === 'vehicle' ? 'vehicle'
          : legacyEntryAlloc,
      }));
    } else if (log.location || log.gallons || log.amount || log.mileage) {
      fillUps = [{
        location: log.location || '',
        gallons: log.gallons || '',
        amount: log.amount || '',
        mileage: log.mileage || '',
        equipmentDescription: log.equipmentDescription || '',
        fuelAllocation: legacyEntryAlloc,
      }];
    }

    // If no fill-ups, still show the mileage/job row once.
    if (fillUps.length === 0) {
      return [{ ...base, repair_fillup_location: '', gallons_fuel: '', total_amount: '', mileage_at_repair_fillup: '' }];
    }
    return fillUps.map((f, i) => {
      const fuAlloc = f.fuelAllocation || 'vehicle';
      return {
        ...base,
        fuel_allocation: fuAlloc,
        equipment_description: fuAlloc === 'equipment' ? (f.equipmentDescription || '') : '',
        // Only the first row repeats the mileage/job; continuation rows blank them.
        mileage_start: i === 0 ? base.mileage_start : '',
        mileage_end: i === 0 ? base.mileage_end : '',
        job_number: i === 0 ? base.job_number : '',
        // Equipment-allocated fill-ups hide location/mileage.
        repair_fillup_location: fuAlloc === 'equipment' ? '' : (f.location || ''),
        gallons_fuel: f.gallons || '',
        total_amount: f.amount || '',
        mileage_at_repair_fillup: fuAlloc === 'equipment' ? '' : (f.mileage || ''),
      };
    });
  })
    // Hide untouched skeleton rows — only meaningful entries show.
    .filter((log) => {
      if (log.day_off) return true;
      return (
        log.mileage_start ||
        log.mileage_end ||
        log.job_number ||
        log.repair_fillup_location ||
        log.gallons_fuel ||
        log.total_amount ||
        log.mileage_at_repair_fillup
      );
    });

  // Extract safety checks
  const safetyChecks = {};
  rowData?.json_data
    ?.filter((item) => item.question.includes('Vehicle Safety Check'))
    ?.forEach((item) => {
      const checkName = item.question
        .replace(' Vehicle Safety Check (Part-1) - ', '')
        .replace(' Vehicle Safety Check (Part-2) - ', '')
        .trim();
      safetyChecks[checkName] = item.answer;
    });
const fetchImages = async () => {
  try {
    setLoader(true);

    // Check if images are already uploaded refs (new mobile draft format)
    const sigItem = driverSignature?.[0];
    if (isUploadedRef(sigItem)) {
      setImagesArray({ base64_data: toDisplayUrl(sigItem) });
    }

    if (Array.isArray(commentimages) && commentimages.length > 0 && isUploadedRef(commentimages[0])) {
      setCommentImagesArray(
        commentimages.map((img) => ({ base64_data: toDisplayUrl(img), filename: img.file_name }))
      );
      if (!isUploadedRef(sigItem)) {
        setImagesArray([]);
      }
      return;
    }

    // Legacy path: fetch base64 via API for file_name refs without displayUrl
    const filenames = [];

    if (sigItem?.file_name && !isUploadedRef(sigItem)) {
      filenames.push(sigItem.file_name);
    }

    if (Array.isArray(commentimages) && commentimages.length > 0) {
      commentimages.forEach((img) => {
        if (img?.file_name && !isUploadedRef(img)) filenames.push(img.file_name);
      });
    }

    if (filenames.length === 0) {
      if (!isUploadedRef(sigItem)) {
        setImagesArray([]);
        setCommentImagesArray([]);
      }
      return;
    }

    const queryParams = filenames
      .map((name) => `filenames=${encodeURIComponent(name)}`)
      .join("&");

    const response = await api.get(`/v1/documents/view-multiple?${queryParams}`);

    if (response.status === 200 && Array.isArray(response?.images)) {
      const orderedImages = filenames.map(
        (name) => response.images.find((img) => img.filename === name) || null
      );

      if (!isUploadedRef(sigItem)) {
        const driverImage = orderedImages[0] ? [orderedImages[0]] : [];
        setImagesArray(driverImage[0]);
      }
      const commentImageArray = orderedImages.slice(isUploadedRef(sigItem) ? 0 : 1).filter(Boolean);
      setCommentImagesArray(commentImageArray);
    } else {
      if (!isUploadedRef(sigItem)) setImagesArray([]);
      setCommentImagesArray([]);
    }
  } catch (error) {
    console.error("Error fetching images:", error);
    setImagesArray([]);
    setCommentImagesArray([]);
  } finally {
    setLoader(false);
  }
};

const checksignatureImage = async (userId) => {
  console.log("Checking signature for user:", userId);

  const cacheBuster = new Date().getTime();
  const signatureUrl = `https://hub2.ntactops.com/ntact/files/user_signatures/${userId}_signature.png?cb=${cacheBuster}`;

  try {
    // Convert the image URL to Base64 via API
    const response = await api.post("/v1/images/to-base64", {
      image_url: signatureUrl,
    });

    if (response.status === 200 && response.data?.base64) {
      const base64String = response.data.base64;

      // ✅ Create base64 data URL for <img>
      const base64Image = `data:image/png;base64,${base64String}`;

      setSignPreview(base64Image); // <-- this updates your state for <img src={signPreview} />
    } else {
      console.warn("Signature not found or invalid response:", response);
      setSignPreview(null);
    }
  } catch (error) {
    console.error("Error fetching signature:", error);
    setSignPreview(null);
  }
};

useEffect(() => {
    fetchImages();
}, []);

// Fetch DF signatures for already-signed users
useEffect(() => {
  if (!df_data) return;
  Object.entries(df_data).forEach(([userId, entry]) => {
    const isSigned = typeof entry === 'object' ? entry?.status === 'Y' : entry === 'Y';
    if (isSigned) {
      fetchDfSignature(userId);
    }
  });
}, [df_data]);
useEffect(() => {
  console.log(pm_status, 'ww');

  if (pm_status === 'Y' && pm_sign) {
    // Extract number before underscore
    const match = pm_sign.match(/^(\d+)_/);
    if (match) {
      const numberBeforeUnderscore = match[1];
      console.log('Extracted number:', numberBeforeUnderscore);
      
  checksignatureImage(numberBeforeUnderscore)
      // You can use the extracted number here if needed
    }
  }
;
}, [pm_status]);

  // Extract comments
  const comments = rowData?.json_data?.find((item) => item.question === 'Comments')?.answer || 'No comments provided.';

  // Extract checked by and signature
  const checkedBy = rowData?.json_data?.find((item) => item.question === 'Checked By')?.answer || 'N/A';
  const driverSignature = rowData?.json_data?.find((item) => item.question === 'Signature')?.answer || 'N/A';
const commentimages =
  rowData?.json_data?.find(
    (item) =>
      item.question === "Comments - Uploaded Images" ||
      item.question === "Upload Images"
  )?.answer || "N/A";


  const generatePDF = async () => {
    try {


      const blob = await import('@react-pdf/renderer').then(({ pdf }) =>
        pdf(
          <PDFDocument
            imagesarray={imagesarray}
            driverName={driverName}
            unitNumber={unitNumber}
            filledDate={filledDate}
            logData={logData}
            safetyChecks={safetyChecks}
            comments={comments}
            checkedBy={checkedBy}
            driverSignature={driverSignature}
            commentImageArray={commentimagesarray}
            pm_name={pm_name}
            pm_sign={pm_sign}
            pm_status={pm_status}
            signpreview={signpreview}
            dfData={df_data}
            dfSignPreviews={dfSignPreviews}
            dfSignOffNotes={dfSignOffNotesFromServer}
          />
        ).toBlob()
      );
      setPdfBlob(blob);
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  

  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollTop = 0;
    }
  }, []);

  const handleBackdropClick = (e) => {
    // Check if the click target is the backdrop itself (not the modal content)
    if (e.target === e.currentTarget) {
      setFormView(false);
    }
  };

  return (
    <div  onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 ">
      <div className="relative w-full max-w-4xl  flex flex-col justify-center items-center p-6 bg-white rounded-lg border border-gray-300 shadow-md overflow-y-auto custom-scrollbar max-h-[95vh]">
        <div className="w-full flex justify-between items-end">
          <div className="flex gap-3">
            <button
              onClick={generatePDF}
              className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
            >
              Print
            </button>
            {typeof onEdit === "function" && (
              <button
                onClick={onEdit}
                className="bg-[#1E4976] text-white px-4 py-1 rounded hover:bg-[#163659]"
              >
                Edit
              </button>
            )}
          </div>
          <button
            onClick={() => setFormView(false)}
            className="text-gray-600 hover:text-black"
          >
            <CloseIcon />
          </button>
        </div>

        <div ref={formRef} className="w-[90%] mt-4 mx-auto overflow-y-auto custom-scrollbar p-4">
          {/* Form Header */}
          <div className="border-b border-gray-700 pb-2 mb-4">
            <div className="flex w-full justify-between">
              <img src={NtactLogo} alt="NTACT Logo" />
              <div>
                <h2 className="text-lg font-semibold">WEEKLY DRIVER LOG & SAFETY</h2>
              </div>
              <div className="mr-24"></div>
            </div>
          </div>

          {/* Driver Info */}
    {/* Row 1 */}
<div className="grid grid-cols-2 gap-4 mb-4">
  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Driver:</p>
    <p className="text-left font-inter p-1 px-2">{driverName}</p>
    <hr className="border-t border-[#9CA3AF]" />
  </div>

  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Date:</p>
    <p className="text-left font-inter p-1 px-2">{filledDate}</p>
    <hr className="border-t border-[#9CA3AF]" />
  </div>
</div>

{/* Unit Number box */}
<div className="border border-[#9CA3AF] p-1 mb-4">
  <p className="text-sm font-inter font-semibold text-left">
    Unit #:
  </p>
  <p className="text-left text-xs font-inter p-1 px-2">
    {unitNumber}
  </p>
</div>

          {/* Log Table */}
          <div className="mb-4">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Date</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage Start</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage End</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Job #</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Repair/Fill-up Location</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Gallons Fuel</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Total Amount</th>
                    <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage @ Repair/Fill-up</th>
                  </tr>
                </thead>
                <tbody>
                  {logData.length > 0 ? (
                    logData.map((log, index) => {
                      const cell =
                        "border border-gray-300 p-2 text-sm font-inter text-center";
                      const muted = `${cell} text-gray-400`;
                      const dateText = log.date
                        ? `${log.dayLabel ? log.dayLabel + ", " : ""}${log.date}`
                        : log.dayLabel || "—";

                      // Merge same-date rows: show Date, Mileage Start & End
                      // only on the first row of each date group using rowSpan.
                      const isFirstOfDate =
                        index === 0 || log.date !== logData[index - 1].date;
                      let sameDateCount = 0;
                      if (isFirstOfDate) {
                        for (
                          let i = index;
                          i < logData.length && logData[i].date === log.date;
                          i++
                        ) {
                          sameDateCount++;
                        }
                      }

                      // Day-off row — just the date + a "Day Off" span.
                      if (log.day_off) {
                        return (
                          <tr key={index}>
                            {isFirstOfDate && (
                              <td
                                className={`${cell} align-middle`}
                                rowSpan={sameDateCount}
                              >
                                {dateText}
                              </td>
                            )}
                            <td
                              colSpan={7}
                              className={`${cell} italic text-gray-500`}
                            >
                              Day Off
                            </td>
                          </tr>
                        );
                      }
                      // Equipment row — description in the location column;
                      // gallons + amount; mileage / job not applicable.
                      if (log.fuel_allocation === "equipment") {
                        return (
                          <tr key={index}>
                            {isFirstOfDate && (
                              <td
                                className={`${cell} align-middle`}
                                rowSpan={sameDateCount}
                              >
                                {dateText}
                              </td>
                            )}
                            {isFirstOfDate && (
                              <td
                                className={`${cell} align-middle`}
                                rowSpan={sameDateCount}
                              >
                                {log.mileage_start || "—"}
                              </td>
                            )}
                            {isFirstOfDate && (
                              <td
                                className={`${cell} align-middle`}
                                rowSpan={sameDateCount}
                              >
                                {log.mileage_end || "—"}
                              </td>
                            )}
                            <td className={muted}>—</td>
                            <td className={cell}>
                              <span className="inline-block text-[10px] font-semibold bg-amber-100 text-amber-700 rounded px-1 mr-1">
                                Equipment
                              </span>
                              {log.equipment_description || "—"}
                            </td>
                            <td className={cell}>{log.gallons_fuel || "—"}</td>
                            <td className={cell}>{log.total_amount || "—"}</td>
                            <td className={muted}>—</td>
                          </tr>
                        );
                      }
                      return (
                        <tr key={index}>
                          {isFirstOfDate && (
                            <td
                              className={`${cell} align-middle`}
                              rowSpan={sameDateCount}
                            >
                              {dateText}
                            </td>
                          )}
                          {isFirstOfDate && (
                            <td
                              className={`${cell} align-middle`}
                              rowSpan={sameDateCount}
                            >
                              {log.mileage_start || "—"}
                            </td>
                          )}
                          {isFirstOfDate && (
                            <td
                              className={`${cell} align-middle`}
                              rowSpan={sameDateCount}
                            >
                              {log.mileage_end || "—"}
                            </td>
                          )}
                          <td className={cell}>{log.job_number || "—"}</td>
                          <td className={cell}>{log.repair_fillup_location || "—"}</td>
                          <td className={cell}>{log.gallons_fuel || "—"}</td>
                          <td className={cell}>{log.total_amount || "—"}</td>
                          <td className={cell}>{log.mileage_at_repair_fillup || "—"}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="border border-gray-300 p-2 text-sm font-inter text-center">No log data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Note Section */}
          <div className="mb-4 p-4 border border-gray-300 rounded">
            <p className="text-sm font-inter font-semibold text-left mb-2">NOTE:</p>
            <p className="text-sm font-inter text-left">
              Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.
            </p>
          </div>

          {/* Safety Checklist */}
          <div className="mb-4">
            <p className="text-sm font-inter font-semibold text-center bg-gray-200 p-2 pb-1 mb-2">
              WEEKLY CHECK (YES = GOOD CONDITION, NO = REQUIRES A COMMENT)
            </p>
            <div className="grid grid-cols-2">
              {[
                'ACCIDENT FORM',
                'BATTERY',
                'BELTS',
                'BRAKE FLUID',
                'ENGINE OIL',
                'FIRE EXTINGUISHER (10lb)',
                'FIRST AID KIT',
                'HEADLAMPS & HI-BEAMS',
                'HEATER HOSES',
                'HITCH, RECEIVER, AND PINS',
                'HORN',
                'INSURANCE CARD',
                'JACK & TIRE IRON',
                'LIGHTS (Parking & BRAKE)',
                'MIRRORS',
                'PARKING BRAKE',
                'RADIATOR FLUID',
                'RADIATOR HOSES',
                'SEATBELTS',
                'SPARE TIRE',
                'STEERING FLUID',
                'TIRE PSI',
                'TRANSMISSION OIL',
                'TURN SIGNALS',
                'WASHER FLUID',
                'WINDSHIELD WIPERS',
              ].map((item, index) => (
                <div key={index} className="flex justify-between items-center px-2 border py-4">
                  <p className="text-sm font-inter text-left">{item}</p>
                  <div className="flex space-x-2">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name={`${item}-check`}
                        value="YES"
                        checked={safetyChecks[item]?.toUpperCase() === 'YES'}
                    
                        className={`mr-1 ${safetyChecks[item]?.toUpperCase() === 'YES' ? 'accent-green-600' : ''}`}
                      />
                      <span className={safetyChecks[item]?.toUpperCase() === 'YES' ? 'text-green-600 font-bold' : 'text-gray-400'}>YES</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name={`${item}-check`}
                        value="NO"
                        checked={safetyChecks[item]?.toUpperCase() === 'NO'}
                      
                        className={`mr-1 ${safetyChecks[item]?.toUpperCase() === 'NO' ? 'accent-red-600' : ''}`}
                      />
                      <span className={safetyChecks[item]?.toUpperCase() === 'NO' ? 'text-red-600 font-bold' : 'text-gray-400'}>NO</span>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Comments Section */}
          <div className="mb-4">
            <div className="text-[16px] my-4 text-left font-semibold">COMMENTS (NOTE ANY ITEMS OR REPAIRS NEEDED)</div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm text-wrap text-gray-700 text-left font-inter py-2 px-3">{comments}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
          </div>
<div className="flex flex-wrap gap-4 mt-4 mb-4">
  {commentimagesarray?.map((x, index) => (
    <div
      key={index}
      className="w-44 h-32 flex items-center justify-center border border-gray-300 rounded-lg shadow-md bg-white hover:shadow-lg transition-shadow"
    >
      <img
       onClick={() => openModal(x)}
        src={x?.base64_data}
        alt={`Driver Signature ${index + 1}`}
        className="w-40 h-24 object-contain cursor-pointer"
      />
    </div>
  ))}
</div>


          {/* Signatures */}
          <div className="grid grid-cols-2 gap-4">
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Checked By:</p>
              <p className="text-left font-inter p-1 px-2">{checkedBy}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Driver Signature:</p>
        {imagesarray?.base64_data && (
      <img
        src={imagesarray?.base64_data}
        alt="Driver Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
    )}
              <hr className="border-t border-[#9CA3AF]" />
            </div>
          </div>
                {isModalOpen && selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4"
          // Close modal when clicking on the background overlay
          onClick={closeModal}
        >
          <div
            className="relative bg-white rounded-lg shadow-xl p-2 md:p-4 max-w-4xl max-h-[90vh] flex justify-center items-center"
            // Prevent clicks on the image/content area from closing the modal
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage?.preview?.base64_data|| selectedImage?.base64_data}
              alt={''}
              className="max-w-full max-h-full object-contain" // Use object-contain to fit image within bounds
            />

            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-white bg-gray-800 rounded-full w-8 h-8 flex items-center justify-center text-xl font-bold opacity-75 hover:opacity-100 transition-opacity"
              onClick={closeModal}
              aria-label="Close modal"
            >
              &times;
            </button>
          </div>
        </div>
      )}
         {/* {signpreview?  <div className="grid grid-cols-2 gap-4">
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left">Signed By: Project Manager</p>
              <p className="text-left font-inter p-1 px-2">{pm_name}</p>
              <hr className="border-t border-[#9CA3AF]" />
            </div>
            <div className="border border-[#9CA3AF] p-1">
              <p className="text-sm font-inter font-semibold text-left"> Signature:</p>
       
      <img
        src={signpreview}
        alt="Driver Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
   
              <hr className="border-t border-[#9CA3AF]" />
            </div>
          </div>:<></>} */}

          {/* DF Sign-Off Section — visible when df_status is P (pending) or Y (signed) */}
          {needsSignOff && (
            <div className="mt-6 border border-gray-300 rounded-lg p-4 bg-gray-50">
              <h3 className="text-md font-bold text-gray-800 mb-3">
                Driver Form Sign-Off
              </h3>
              <p className="text-xs text-gray-500 mb-4">
                This form requires sign-off because one or more Vehicle Safety Check items were marked "No".
              </p>

              {/* Show existing sign-offs */}
              {Object.keys(df_data).length > 0 && (
                <div className="grid grid-cols-1 gap-3 mb-4">
                  {Object.entries(df_data).map(([userId, entry]) => {
                    const entryName = typeof entry === 'object' ? entry?.name : '';
                    const preview = dfSignPreviews[userId];
                    const existingNotes = dfSignOffNotesFromServer[userId];

                    return (
                      <div key={userId} className="border border-[#9CA3AF] p-3 rounded-md bg-white">
                        <p className="text-sm font-semibold text-gray-800">
                          {entryName || `User #${userId}`}
                        </p>
                        <hr className="mt-2 mb-2" />

                        {preview && (
                          <>
                            <p className="text-sm font-semibold mt-1">Signature:</p>
                            <img
                              src={preview}
                              alt="DF Signature"
                              className="w-40 h-24 object-contain border rounded mt-2"
                            />
                          </>
                        )}
                        {existingNotes && (
                          <div className="mt-2">
                            <p className="text-xs font-semibold text-gray-600">Sign-off Notes:</p>
                            <p className="text-xs text-gray-700 whitespace-pre-wrap mt-1">{existingNotes}</p>
                          </div>
                        )}
                        <p className="text-xs text-green-600 font-semibold mt-2">&#10003; Signed Off</p>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Sign-off action — any N2 user who hasn't signed yet */}
              {hasN2 && !currentUserSigned && (
                <div className="border border-[#9CA3AF] p-3 rounded-md bg-white">
                  <p className="text-xs text-gray-600 mb-3">
                    Please review the safety check items and sign off.
                  </p>

                  <div className="mb-3">
                    <label className="text-xs font-semibold text-gray-600 block mb-1">
                      Sign-off Notes (optional)
                    </label>
                    <textarea
                      rows={3}
                      className="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:border-blue-500"
                      placeholder="Add any notes about this sign-off..."
                      value={dfSignOffNote}
                      onChange={(e) => setDfSignOffNote(e.target.value)}
                    />
                  </div>

                  <button
                    className="bg-[#2563EB] text-white text-sm px-4 py-2 rounded-md hover:bg-[#1E40AF] w-fit"
                    onClick={handleStartDfSignOff}
                  >
                    Sign Off
                  </button>
                </div>
              )}

              {/* If not N2, just show awaiting message when pending */}
              {!hasN2 && dfStatus === 'P' && Object.keys(df_data).length === 0 && (
                <p className="text-xs text-gray-500 italic">
                  Awaiting sign-off from authorized reviewer...
                </p>
              )}
            </div>
          )}

        </div>
      </div>
      <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
      <SignatureModal
        isModal={dfSignatureModalOpen}
        setModal={(open) => {
          setDfSignatureModalOpen(open);
          // modal closed — no cleanup needed
        }}
        onSave={handleDfSignatureCapture}
      />
    </div>
  );
};

export default WDSFormModal;